import React, { Component } from "react";

let instancesCount = 0;
class editCV extends Component {
  constructor(props) {
    super(props);
    this.myCanvasOuput = React.createRef();
    this.myTextArea = React.createRef();
    this.state = {
      mycode: `let rect = new cv.Rect(0, 0, 500, 200);
dst = src.roi(rect);`,
      errormsg:''
    };
  }

  // Importar librería al cargar componente

  sliderAction(e) {
    const cv = window.cv;
    let tempElement = this.myCanvasOuput.current;
    let tempElement2 = this.myTextArea.current;
    // console.log(tempElement2.value);
    // eval(this.state.mycode);
    // eval(`let imgElement = document.getElementById(\"imageSrc\");\nlet src = cv.imread(imgElement);\nlet dst = new cv.Mat(); // You can try more different parameters\nlet rect = new cv.Rect(0, 0, 500, 200);\ndst = src.roi(rect);\ncv.imshow(\"canvasOutput\", dst);\nsrc.delete();\ndst.delete();`);
    try {
      eval(`let imgElement = e.target.closest(".Component").previousSibling?e.target.closest(".Component").previousSibling.querySelector(".imageTarget"):imageSrc;
        let src = cv.imread(imgElement);let dst = new cv.Mat();${tempElement2.value}cv.imshow(tempElement, dst);
        src.delete();
        dst.delete();`);
        this.setState({errormsg:''});
    } catch (error) {
      this.setState({errormsg:' Se obtuvo un error...'});
      console.error(error);
    }

    // console.log(this.state);
  }
  searchVendor(e) {
    let timeoutId = window.timeoutId;
    clearTimeout(timeoutId);
    window.timeoutId = setTimeout(() => this.sliderAction(e), 100);
  }

  componentDidMount = () => {
    instancesCount += 1;
    console.log({ instancesCount });
  };
  componentWillUnmount = () => {
    instancesCount -= 1;
    console.log({ instancesCount });
  };
  // Render
  render() {
    return (
      <div className="App Component container mt-5" style={{borderTop: "dashed"}}>
        <h2>editCV<small style={{color:"red"}}>{this.state.errormsg}</small></h2>
        
        {/* <button onClick={(e) => this.sliderAction(e)}>Press</button> */}

        <div className="row t-5">
          <div className="inputoutput col-6" align="center">
            <textarea
              id="mytext"
              rows="4"
              cols="50"
              style={{ resize: "auto" , height:"100%"}}
              ref={this.myTextArea}
              defaultValue={this.state.mycode}
              onBlur={(e) => this.searchVendor(e)}
            ></textarea>
          </div>
          <div className="inputoutput col-6">
            <canvas ref={this.myCanvasOuput} className="imageTarget card"></canvas>
            {/* <div className="caption">canvasOutput</div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default editCV;
